import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=2a94d4e6&scoped=true&"
var script = {}
import style0 from "./develop.vue?vue&type=style&index=0&id=2a94d4e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94d4e6",
  null
  
)

export default component.exports